import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";

import BookmarkButton from './BookmarkButton';
import localLibrary from './../utils/localLibrary';

class SavedItemsView extends Component {
	constructor(props) {
		super(props);
	}

	formatDate(date) {
		let d = new Date(date);
		return d.getDay()+'.'+(d.getMonth()+1)+'.'+d.getFullYear();
	}

	render() {
		let savedItems = localLibrary.list();

		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					<div className="column-content saved-items">
						<h3>Mínar örnefnaskrár</h3>
						<hr/>

						{
							savedItems && savedItems.length > 0 &&
							<React.Fragment>
								<p>
									<button className="btn btn-secondary btn-sm" onClick={() => localLibrary.clear()}>Tæma lista</button>
								</p>
								<table className="table">
									<thead>
										<tr>
											<th>Titill</th><th></th>
										</tr>
									</thead>
									<tbody>
										{
											savedItems.map((item, index) => <tr>
												<td key={index}><Link to={'/ornefnaskra/'+item.id}>{item.title}</Link></td><td><small>Bætt við {this.formatDate(item._date_added)}</small><BookmarkButton className="small float-right" {...item} /></td>
											</tr>)
										}
									</tbody>
								</table>
							</React.Fragment>
						}

						{
							(!savedItems || savedItems.length == 0) &&
							<p>Þú hefur ekki vistað neinar skrár.</p>
						}

					</div>
				</div>

			</div>
		);
	}
}

export default withRouter(SavedItemsView);



// WEBPACK FOOTER //
// ./src/components/SavedItemsView.js